import { Component, OnInit, inject } from '@angular/core';
import { ContactVerificationService } from 'src/app/modules/user-profile/services/contact-verification-service';

@Component({
    selector: 'app-contact-verification-fail',
    templateUrl: './contact-verification-fail.component.html',
    styleUrls: ['./contact-verification-fail.component.css'],
    standalone: true
})
export class ContactVerificationFailComponent implements OnInit {
  cservice = inject(ContactVerificationService);


  ngOnInit(): void {
  }

}
